import APIService from '@/api'

export default class APICustomer extends APIService{

    constructor(){
        super('customers')
    }

    create(item) {
        return this.AxiosInstance.post(this.ApiUrl, item, {});
    }

    update(item) {
        return this.AxiosInstance.put(this.ApiUrl + "/" + item.ID, item, {});
    }

    delete(item) {
        return this.AxiosInstance.delete(this.ApiUrl + "/" + item.ID, {});
    }
}




// WEBPACK FOOTER //
// ./src/api/customer.js